import { createReducer } from "redux-create-reducer";
import { ACCTS_ACTIONS } from "./acctsActions";
import { LOCATION_CHANGE } from "react-router-redux";
import { fieldErrorsBackToFront } from "assets/scripts/domain/misc/dataConversion";
export const INITIAL_STATE = {
    isSaving: false,
    saveResult: null,
    saveError: null,
    fieldErrors: [],
    restrictions: null,
    restrictionsLoading: false,
    restrictionsError: null,
    isCancelling: false,
    cancelResult: null,
    cancelError: null
};
export default createReducer(INITIAL_STATE, {
    [ACCTS_ACTIONS.CREATE_CALLBACK_STARTED](state, _action) {
        return {
            ...state,
            isSaving: true,
            saveResult: null,
            saveError: null,
            fieldErrors: INITIAL_STATE.fieldErrors
        };
    },
    [ACCTS_ACTIONS.CREATE_CALLBACK_SUCCEEDED](state, { payload }) {
        const fieldErrors = payload.success
            ? INITIAL_STATE.fieldErrors
            : fieldErrorsBackToFront(payload.errors);
        let { saveResult } = state;
        if (payload.success) {
            saveResult = payload.data.type;
        }
        return {
            ...state,
            isSaving: false,
            saveResult,
            fieldErrors
        };
    },
    [ACCTS_ACTIONS.CREATE_CALLBACK_FAILED](state, { payload }) {
        return {
            ...state,
            isSaving: false,
            saveError: payload,
            fieldErrors: INITIAL_STATE.fieldErrors
        };
    },
    [LOCATION_CHANGE](state, { payload }) {
        const pathname = payload.pathname.toLowerCase();
        if ((pathname.startsWith("/secured/account/") || pathname.startsWith("/secured/callback/"))
            && state.saveResult != null) {
            return {
                ...state,
                saveResult: null,
                saveError: null,
                cancelResult: null,
                cancelError: null
            };
        }
        return state;
    },
    [ACCTS_ACTIONS.LOAD_RESTRICTIONS_STARTED](state, _action) {
        return {
            ...state,
            restrictionsLoading: true
        };
    },
    [ACCTS_ACTIONS.LOAD_RESTRICTIONS_SUCCEEDED](state, { payload }) {
        return {
            ...state,
            restrictions: payload,
            restrictionsLoading: false,
            restrictionsError: null
        };
    },
    [ACCTS_ACTIONS.LOAD_RESTRICTIONS_FAILED](state, { payload }) {
        return {
            ...state,
            restrictionsLoading: false,
            restrictionsError: payload
        };
    },
    [ACCTS_ACTIONS.CANCEL_CALLBACK_STARTED](state, _action) {
        return {
            ...state,
            isCancelling: true,
            cancelResult: null,
            cancelError: null
        };
    },
    [ACCTS_ACTIONS.CANCEL_CALLBACK_SUCCEEDED](state, { payload }) {
        return {
            ...state,
            isCancelling: false,
            cancelResult: payload.cancelled
        };
    },
    [ACCTS_ACTIONS.CANCEL_CALLBACK_FAILED](state, { payload }) {
        return {
            ...state,
            isCancelling: false,
            cancelError: payload
        };
    }
});



// WEBPACK FOOTER //
// ./src/assets/scripts/domain/accts/callbackReducer.ts